import App from './App.svelte';

new App({
  target: document.querySelector('main')
});